import React,{ useState, useEffect } from 'react';
import { 
    Alert,
    Card,
    Input,
    Form,
    Button
} from 'antd';

import { 
    CheckCircleOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    MinusOutlined
} from '@ant-design/icons';

import MaskedInput from "antd-mask-input";

const siteDomain = headerVars.siteDomain;

function TransferNumber( {
    handleRemoveFromCustomerPhoneNumberArray,
    showRemoveInputButton,
    setCustomerPhoneNumberValid,
    transferNumberStatus,
    setTransferNumberStatus,
    inputId
} ) {

    const [customerPhoneNumberValidSuffix, setCustomerPhoneNumberValidSuffix] = useState(<></>);
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState('');
    const [addInputSelected, setAddInputSelected] = useState(false);
    const [transferStatus, setTransferStatus] = useState('');
    const [form] = Form.useForm();

    useEffect(() => { 
        let numberStatus = ( customerPhoneNumber == '' && transferNumberStatus == '' ) ? '': 'error';
        setTransferStatus( numberStatus );
     }, [ transferNumberStatus, setTransferNumberStatus, customerPhoneNumber, setTransferStatus ]);

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        let isValid = true;
        let validationSuffix = <></>;

        if( !currentVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
            isValid = false;
        }

        validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

        let customerPhone = isValid ? currentVal : '';

        setCustomerPhoneNumber( currentVal );
        setCustomerPhoneNumberValidSuffix( validationSuffix );
        setCustomerPhoneNumberValid( isValid );
        setTransferStatus('');
    }

    const handleRemoveNumberInput = () => {
        handleRemoveFromCustomerPhoneNumberArray( inputId );
    }

    return (
        <>
            <Form.Item
                label="Number(s) to transfer"
                //labelCol={{ span: 24 }}
                name="firstname"
                style={{paddingRight:'1rem', marginBottom:'0.5rem', width:'100%'}}
                rules={[
                    {
                    required: false,
                    message: '',
                    },
                ]}
            >
                <MaskedInput
                    className="transfer-form-customer-phone-number"
                    mask={'(000) 000-0000'}
                    style={{ marginRight: '0.5rem', marginBottom: '0.5rem' }}
                    id={ `transfer-form-customer-phone-number${inputId}` }
                    suffix={ customerPhoneNumberValidSuffix }
                    onChange={handleOnInputChange}
                    status={ transferStatus }
                />
            <Button
                //type={ primary }
                style={{ display: ( showRemoveInputButton ) ? 'inline-block' : 'none' }} 
                shape="circle" 
                size='small'
                icon={<MinusOutlined />}
                onClick={ handleRemoveNumberInput }
            />
            </Form.Item>
        </>
    )
}

export default TransferNumber
